import { makeStyles } from '@material-ui/core';

import { Organization } from '../../types/organization.type';
import DeliveryPointsTable from '../Tables/DeliveryPointsTable.component';
import AddDeliveryPointsDialog from '../Modals/AddDeliveryPointsDialog.component';

type Props = {
  organization: Organization;
  refreshOrganization: () => Promise<void>;
};

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.5rem',
  },

  header: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
});

export default function OrganizationDeliveryPointsTab({ organization, refreshOrganization }: Props) {
  const classes = useStyles();

  const deliveryPoints = organization.deliveryPoints ?? [];
  console.log(deliveryPoints);

  return (
    <section className={classes.root}>
      <div className={classes.header}>
        <AddDeliveryPointsDialog
          actionLabel="Ajouter"
          organizationId={organization.id}
          currentDeliveryPointIds={deliveryPoints.map((deliveryPoint) => deliveryPoint.id)}
          refreshOrganization={refreshOrganization}
        />
      </div>
      <DeliveryPointsTable
        maxHeight="74svh"
        deliveryPoints={deliveryPoints}
        organizationId={organization.id}
        refreshOrganization={refreshOrganization}
      />
    </section>
  );
}
